export default __webpack_public_path__ + "static/media/reebokW.427d3cda.png";